import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RouterList from './routerList';
// import zhCN from 'antd/locale/zh_CN';
import { ConfigProvider } from "antd"
import Header from "../components/header/header";
import { getUserInfo } from '../api/user';
import TokenStore from '../store/tokenStore';
import UserInfoStore from '../store/userInfoStore';

const RootLayout = () => {
  useEffect(()=>{
   // !TokenStore.token&&TokenStore.removeToken();//退出登录
    TokenStore.token && getUserInfo({}).then(res => {
        UserInfoStore.setUserInfo(res.result)
    });
},[])
  return (
    <BrowserRouter >
      <ConfigProvider>
      <Header />
        <Routes >
          {RouterList.map((item, index) => {
            return <Route key={index} path={item.path} element={item.element} />;
          })}
        </Routes>
      </ConfigProvider>
      
    </BrowserRouter>
  );
};

export default RootLayout;